import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";
import { fade } from "@material-ui/core/styles/colorManipulator";

const useStyles = makeStyles(({ palette, spacing }) => ({
  headCell: {
    background: palette.attachmentsBackground.main,
    borderTop: `1px solid ${palette.separator.main}`,
    padding: spacing(0, 1.5),
    alignItems: "center",
    minWidth: "200px",
    maxWidth: "270px",
    width: "100%",
    height: "100%",
    borderBottom: `1px solid ${palette.separator.main}`,
    position: "relative",
    justifyContent: "space-between",
    "&:focus path": {
      visibility: "visible",
    },
    "&:hover path": {
      visibility: "visible",
    },
  },
  columnHeadCell: {
    width: "100%",
    minWidth: "200px",
    maxWidth: "270px",
  },
  lastHeadCell: {
    borderRadius: "0px 8px 0px 0px",
    borderRight: `1px solid ${palette.separator.main}`,
  },
  index: {
    fontSize: "10px",
    lineHeight: "120%",
    color: grey[400],
  },
  rowIndex: {
    position: "absolute",
    right: "206px",
  },
  headRowCell: {
    borderTop: "none",
    borderLeft: `1px solid ${palette.separator.main}`,
    borderRight: `1px solid ${palette.separator.main}`,
    background: "white",
    "&:last-child": {
      borderRadius: "0px 0px 0px 8px",
    },
  },
  headCellInput: {
    all: "unset",
    resize: "none",
    color: palette.contrastText.main,
    margin: "11px 0",
    padding: "5px 0",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "120%",
    width: "100%",
    paddingRight: spacing(2.5),
    overflow: "hidden",
    "&:focus": {
      border: `1px solid ${palette.primary.main}`,
      borderRadius: "2px",
      background: "white",
      margin: "10px 0",
    },
    "&:hover": {
      border: `1px solid ${palette.primary.main}`,
      borderRadius: "2px",
      background: "white",
      margin: "10px 0",
      "&:disabled": {
        border: "none",
        borderRadius: "none",
        background: fade(palette.contrastText.main, 0.34),
        margin: "11px 0",
      },
    },
  },
  headCellInputEmptyValue: {
    border: `1px solid ${palette.error.main} !important`,
    borderRadius: "2px",
    background: "white",
    margin: "10px 0",
  },
  hiddingBox: {
    top: 0,
    left: 0,
    position: "sticky",
    zIndex: 1,
    background: "white",
    width: "100%",
    minWidth: "200px",
    maxWidth: "270px",
  },
  uponLeftCell: {
    height: "12px",
    width: "100%",
    minWidth: "200px",
    maxWidth: "270px",
    borderRight: `1px solid ${palette.separator.main}`,
  },
  leftCell: {
    minWidth: "200px",
    borderRadius: "8px 0px 0px 0px",
    borderLeft: `1px solid ${palette.separator.main}`,
    borderBottom: `1px solid ${palette.separator.main}`,
  },
  cell: {
    width: "200px",
    height: "48px",
    padding: spacing(0, 1.5),
    borderRight: `1px solid ${palette.separator.main}`,
    borderBottom: `1px solid ${palette.separator.main}`,
  },
  cellInput: {
    border: `1px solid ${palette.separator.main}`,
    borderRadius: "2px",
    width: "100%",
    padding: spacing(0, 0.5),
  },
  cellInputText: {
    fontSize: "12px",
    lineHeight: "120%",
    color: grey[500],
  },
  cellButton: {
    padding: spacing(0.5),
  },
  rowTitles: {
    position: "sticky",
    top: 0,
    left: 0,
    height: "100%",
    zIndex: 10000,
  },
  checkboxLabel: {
    color: grey[500],
    fontSize: "14px",
    lineHeight: "19px",
    letterSpacing: "0.15px",
  },
  icon: {
    width: "16px",
    height: "16px",
  },
  disableDeleteColumnSVG: {
    fill: grey[300],
  },
  deleteColumnButton: {
    width: "16px",
    minWidth: "16px",
    maxWidth: "16px",
    marginLeft: spacing(0.25),
    "& path": {
      visibility: "hidden",
    },
    padding: 0,
  },
  makeColumnMandatoryButton: {
    position: "absolute",
    padding: "4px",
    minWidth: "16px",
    right: "30px",
    "& path": {
      visibility: "hidden",
    },
    "& .MuiButton-label": {
      width: "16px",
    },
  },
  leftBorder: {
    borderLeft: `1px solid ${palette.separator.main}`,
    borderRadius: "8px 0px 0px 0px",
  },
  firstColumn: {
    marginLeft: "20px",
  },
}));

export default useStyles;
